import { useState , useEffect} from "react";
import BillPrintView from "./BillPrintView";
import HotelBillEntry from "./HotelBillEntry";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
 

export default function BillingHome() {
     const userData = useSelector((state) => state.authentication.userData);
  
  const API_BASE = `${process.env.REACT_APP_COLLEGE_ERP_API}`;
    const location = useLocation();
  const reservation = location.state?.reservation;
  const [bill, setBill] = useState({
    invoiceNo: "",
    date: "",
    room: "",
    paymentMode: "",
    guest: "",
    address: "",
    city: "",
    zip: "",
    gstin: "",
    phone: "",
    items: [],
    total: 0,
  });
 

  const handleSave = async () => {
  try {
    const savedBill = await saveBill(); // Ensure saved first

    // After saving, print
   alert("Bill saved successfully! Now printing...");

  } catch (err) {
    alert("Failed to save bill before printing");
  }
};

const saveBill = async () => {
  try {
    let response;

  //  // If bill already has _id → UPDATE
  //  if (bill._id) {
  //    response = await axios.put(
  //      `${API_BASE}hotel/bills/${bill._id}`,
  //      bill,
  //      {
  //        headers: {
  //          Authorization: `Bearer ${userData.token}`,
  //        },
  //      }
  //    );
  //  } 
    // If no _id → CREATE
 //   else {
      response = await axios.post(
        `${API_BASE}bills/${userData.branch}`,
        bill,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
     console.log("Bill saved:", response.data);
      // Save returned _id into state
      setBill((prev) => ({ ...prev, _id: response.data._id, invoiceNo: response.data.invoiceNo }));
 //   }

    return response.data;
  } catch (error) {
    console.error("Error saving bill:", error);
    throw error;
  }
};


 
useEffect(() => {
  if (!reservation) return;

  const invoiceDate = new Date().toISOString().split("T")[0];

  const checkIn = reservation.checkInDate
    ? new Date(reservation.checkInDate).toISOString().split("T")[0]
    : "";

  const checkOut = reservation.checkOutDate
    ? new Date(reservation.checkOutDate).toISOString().split("T")[0]
    : "";

  const pricePerNight = Number(reservation.pricePerNight || 0);
  const nights = Number(reservation.nights || 0);
  const roomRent = pricePerNight * nights;

  // GST calculation (2.5% + 2.5%)
  const cgst = roomRent * 0.025;
  const sgst = roomRent * 0.025;
  const total = roomRent + cgst + sgst;

  setBill({
    reservationId: reservation._id,
    invoiceDate,
    invoiceNo: "", // you can auto-generate later
    checkIn,
    checkOut,
    room: reservation.roomId,
    paymentMode: reservation.paymentMode || "",
    billTo: reservation.guestName,
    gstin: "", // optional
    phone: reservation.mobile,

    items: [
      {
        date: invoiceDate,
        description: `Room Rent (${nights} Night${nights > 1 ? "s" : ""})`,
        charges: roomRent.toFixed(2),
        credit: "",
        cgst: cgst.toFixed(2),
        sgst: sgst.toFixed(2),
        total: total.toFixed(2),
      }
    ]
  });

  console.log("Reservation Data:", reservation);

}, [reservation]);

  return (
    <>
      <HotelBillEntry bill={bill} setBill={setBill} handleSave={handleSave} />
      <BillPrintView bill={bill} handleSave={handleSave} />
    </>
  );
}
